module.exports = "img/flags/SN.aec5b10.png";